import { createHead } from "@unhead/vue/client";

export const headInstance = createHead();
